import type { CartItem } from "../../model/product.cart.model";
import type { PricingStatus } from "../../model/form.model";

export type StepValidation = { ok: true } | { ok: false; reason: string };

export function validateProductsStep(args: {
  cart: CartItem[];
  pricingStatus: PricingStatus;
}): StepValidation {
  const { cart, pricingStatus } = args;

  if (!cart.length)
    return { ok: false, reason: "Adicione ao menos um produto." };

  if (pricingStatus === "loading")
    return { ok: false, reason: "Aguarde o cálculo de preços." };

  if (cart.some((p) => !Number(p.quantity) || Number(p.quantity) < 1)) {
    return {
      ok: false,
      reason: "Todos os produtos devem ter quantidade acima de 0.",
    };
  }

  return { ok: true };
}
